import { withTranslation } from 'react-i18next';
import CatalogFooter from './CatalogFooter';

export default withTranslation()(CatalogFooter);
